import { createContext, useContext, useSyncExternalStore } from "react";
import type { LanguageController } from "./languageController";
export const DashboardLanguageContext = createContext<LanguageController | null>(null);
export function useLanguageController() {
  const controller = useContext(DashboardLanguageContext);
  if (!controller) throw new Error("LanguageProvider is required");
  return controller;
}
export function useDashboardLanguage() {
  const controller = useLanguageController();
  const state = useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
  return { ...state, apply: controller.apply, retryCatalog: controller.retryCatalog, retryContext: controller.retryContext };
}
